import api from '@/logic/api'

export default {
  getLikeStatus: (foreignType, foreignId) => api.get(`/likes/${foreignType}/${foreignId}/likesIt`),
  like: (foreignType, foreignId) => api.post(`/likes/${foreignType}/${foreignId}/like`),
  dislike: (foreignType, foreignId) => api.post(`/likes/${foreignType}/${foreignId}/dislike`),
}
